import { get } from 'lodash';

import { i18n } from '@lt/localization';
import { HOTEL_FACTS_TEXTS, HOTEL_FACTS_TYPES } from '../constants/hotelFacts';
import { timeBySpeedGen } from '../../../utils/dateUtils';
import { roundToDecimals } from '../../../utils/numberUtils';
import { NBSP } from '../../../constants/common';

const getDistanceText = (distance) => {
  const useMeters = distance < 1000;
  const value = useMeters ? distance : roundToDecimals(distance, 1);
  const unit = i18n.t('hotel.facts.distance', {
    context: useMeters ? 'm' : 'km',
  });

  return `${value}${NBSP}${unit}`;
};

/**
 * @param {string} type
 * @param {any} data
 * @returns {object}
 */
const getFactsItemData = (type, data) => {
  if (!data || data === 'NONE') {
    return null;
  }

  let title = '';
  let subtitle = '';
  let iconText = null;
  let iconName = '';

  switch (type) {
    case HOTEL_FACTS_TYPES.AIRPORT:
      title = i18n.t('hotel.facts.airport.title', {
        context: data > 10000 ? 'far' : 'nearby',
      });
      subtitle = `${i18n.t('hotel.facts.airport.subtitle')} ${timeBySpeedGen(
        data,
      )}`;
      iconName = 'plane';
      break;
    case HOTEL_FACTS_TYPES.BEACHLINE: {
      const { distance, line } = data;

      if (!line) {
        return null;
      }

      title = HOTEL_FACTS_TEXTS[type][line].title;
      subtitle = `${i18n.t('hotel.facts.beachline.subtitle')} ${i18n.t(
        'hotel.facts.beachline.title',
        { context: line === 3 ? 'about' : 'all' },
      )} ${getDistanceText(distance)}`;
      iconText = `${line}${i18n.t('hotel.facts.beachline.line')}`;
      iconName = HOTEL_FACTS_TEXTS[type][line].iconName;
      break;
    }
    case HOTEL_FACTS_TYPES.SKI_LIFT:
      title = HOTEL_FACTS_TEXTS[type].title;
      iconName = HOTEL_FACTS_TEXTS[type].iconName;
      subtitle = `${i18n.t('hotel.facts.skiLift.in')} ${getDistanceText(data)}`;
      break;
    default: {
      const elementType = HOTEL_FACTS_TEXTS[type] || {};
      const hasTitle = Boolean(elementType.title);
      const element = hasTitle
        ? elementType
        : get(elementType, String(data).toUpperCase(), {});

      title = element.title; // eslint-disable-line prefer-destructuring
      subtitle = element.subtitle; // eslint-disable-line prefer-destructuring
      iconName = element.iconName || String(type).toLowerCase();
      break;
    }
  }

  return {
    title,
    subtitle,
    iconText,
    iconName,
  };
};

export default getFactsItemData;
